import getValueReduxUtil from 'modules/redux/utils/get-value'
import { WORKOUT_KEY } from 'modules/training/models/workout/constants'

function getDurationWorkoutUtil (instance) {
  return getValueReduxUtil(
    instance, WORKOUT_KEY.DURATION
  )
}

export default getDurationWorkoutUtil
